import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { useGlobalAlert } from "../Common/Context/GlobalAlertContext";
import StickyPageLayout from "../Layout/PageLayout/StickyPageLayout";
import CategorySubcategoryView from "./CategorySubcategoryView";

 
  
const CatgSubForm = () => {
  const navigate = useNavigate();
  const { showAlert } = useGlobalAlert();
 
  const location = useLocation();
  const [submitLoading, setSubmitLoading] = useState(false);

  

  const listProps = {
    type: 'button',
    text: 'List',
    onClick: () => {navigate('/admin/catg-sub-list')}, // 👈 important
    style: { backgroundColor: '#333', color: '#fff' }
   };
  const submitProps = {
    type: 'submit',    
    loading:submitLoading,
  };
  return (
    <StickyPageLayout
      title="Manage Category"          
      submitProps={{...submitProps,
      //  onClick:handleSubmit,
        className:'btn-modern btn-blue'}}
      listProps={listProps}
    > 
    <CategorySubcategoryView
    />
       
    </StickyPageLayout>
  );
};

export default CatgSubForm;